import { CategoriesKeys } from '@gamiphy/bl/mission/enums';

export const SINGLE_MISSION_CATEGORIES = [
  CategoriesKeys.facebook,
  CategoriesKeys.tiktok,
  CategoriesKeys.instagram,
  CategoriesKeys.x,
  CategoriesKeys.birthday,
  CategoriesKeys.social,
];
